import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
import { IListObj } from "../../../../types/genericTypes";
import { AccounTypeSection } from "../common/accountTypeSection";
import { NomineeDisplaySection } from "../common/nomineeDisplaySection";
import * as esignService from "../../../../service/esign/esignService";
import LoginService from "../../../../service/login/loginService";
import {
  ageCalculator,
  applicantRelationships,
  NOMINEE,
} from "../addNominee/constant";
import { IdentificationForNominee } from "./identificationForm";
import { NomineeGuardianForm } from "../addNominee/form";
import { ShowDetails } from "../addNominee/showDetails";
import { DpTrading } from "../common/dpTrading";
import { GetPersonDetails } from "../../../../service/serviceRequest/srApiService";

const nomineeRef: any = [];
const guardianRef: any = [];

const accTypes: Array<IListObj> = [
  { value: "tradingDemat", display: "Trading + Demat" },
  { value: "demat", display: "Demat" },
  { value: "trading", display: "Trading" },
];

export const Replication = forwardRef((props: any, ref: any) => {
  const [dpOptions, setDpOptions] = useState<any>([]);
  const [selectedDp, setSelectedDp] = useState<any>("");
  const [userPan, setUserPan] = useState<string>("");
  //

  //nominee dropdoptions
  const [nominOptions, setNominOptions] = useState<any>([]);
  const [selectedNominee, setSelectedNominee] = useState<any>("");
  //

  //
  const [selectedAcc, setSelectedAcc] = useState<any>(accTypes[0].value);
  const [dpToReplicate, setDpToReplicate] = useState<any>({});
  const [totalNominee, setTotalNominee] = useState<any>([]);
  const [oldNominees, setoldNominees] = useState<any>([]);
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [errors, setErrors] = useState<any>({
    dp: "",
    selectedNominee: "",
  });
  const [editNomin, setEditNomin] = useState<any>(true);
  const [DPType, setDPType] = useState<string>("");
  const [GuardianData, setGuardianData] = useState<any>([]);
  const [sameGuardian, setSameGuardian] = useState<boolean | undefined>(
    undefined
  );
  const [updateShowDetails, setUpdateShowDetails] = useState<boolean>(false);
  const [isGuardianAvailable, setIsGuardianAvailable] =
    useState<boolean>(false);
  useEffect(() => {
    let dpId = selectedDp;
    if (!selectedDp || selectedAcc === "trading") {
      //if only trading visible/ trading option selected
      if (props.nomineeDet)
        props.nomineeDet[0].DematDetails.forEach((ele: any) => {
          if (ele.DefaultDemat === "Yes") dpId = ele.Demat_Account_Number;
        });
    }
    // //console.log('dpId',dpId);

    let reqObj = {
      acTyp: LoginService.getAccData("accTyp"),
      dpId: dpId,
      trdOpt: false,
      dpOpt: false,
      trdUpd: selectedAcc.includes("trading"),
      dpUpd: selectedAcc.toLowerCase().includes("demat"),
      reqTyp:
        (selectedAcc === "tradingDemat" && "trading+demat") ||
        (selectedAcc === "trading" && "trading") ||
        (selectedAcc === "demat" && "demat"),
      nomTyp: "Modification",
      nominees: totalNominee,
    };
    ////console.log("reqObj", reqObj);

    // props.payload(reqObj);
    // let hasErr = false;

    // totalNominee.forEach((ele: any) => {
    //   if (
    //     !(
    //       ele.aadhar ||
    //       ele.bankAcc ||
    //       ele.pan ||
    //       ele.dpId ||
    //       ele.attachment.nm
    //     ) ||
    //     (ele.minor &&
    //       !(
    //         ele.guard.aadhar ||
    //         ele.guard.bankAcc ||
    //         ele.guard.pan ||
    //         ele.guard.dpId ||
    //         ele.guard.attachment.nm
    //       ))
    //   )
    //     hasErr = true;
    // });

    if (
      // (dpOptions.length > 0 && selectedAcc !== "trading" ? selectedDp : true) &&
      // (nominOptions.length > 1 ? selectedNominee : true) &&
      // selectedAcc &&
      // !errorMsg
      // // &&
      // // !hasErr
      errors.dp ||
      errors.selectedNominee ||
      errorMsg ||
      totalNominee.length > 3 ||
      (selectedNominee && selectedNominee.includes("trading"))
    )
      props.enableSubmit(false);
    else props.enableSubmit(true);
  }, [
    selectedDp,
    selectedAcc,
    selectedNominee,
    totalNominee,
    errorMsg,
    errors,
  ]);

  useEffect(() => {
    if (selectedDp)
      setDPType(
        selectedAcc === "trading"
          ? ""
          : selectedDp.includes("IN")
          ? "NSDL"
          : "CDSL"
      );
  }, [selectedDp, selectedAcc]);

  useEffect(() => {
    //reset nominee details on cancel of edit
    if (!editNomin && oldNominees.length > 0) setTotalNominee(oldNominees);
  }, [editNomin, totalNominee]);
  async function getPersonalDetails() {
    let personaldetails = await GetPersonDetails();
    if (personaldetails && personaldetails.pANNumberField) {
      setUserPan(personaldetails.pANNumberField);
    } else {
      setUserPan("");
    }
  }
  useEffect(() => {
    let resp = props.nomineeDet;

    //nominee dropdown mapping
    let nominDetOptions: any = [];
    props.nomineeDet[0].DematDetails.map((ele: any) => {
      if (ele.DematTagging === "Nominee Available")
        nominDetOptions.push({
          ...ele,
          display:
            "DP ID - " +
            ele.Demat_Account_Number +
            " " +
            " ( " +
            ele.Nominee_Details.length +
            " )",
          value: ele.Demat_Account_Number,
        });
    });
    let tradDet =
      props.nomineeDet[0].TradingDetails.TradingTagging === "Nominee Available"
        ? props.nomineeDet[0].TradingDetails
        : {};
    if (tradDet.TradingTagging)
      nominDetOptions.push({
        ...tradDet,
        display: "Trading - " + tradDet.AccountCode,
        value: "trading",
      });
    if (nominDetOptions.length > 1) {
      if (nominDetOptions.length > 0)
        setNominOptions([
          {
            display: "Select Nominee Details",
            value: "",
          },
          ...nominDetOptions,
        ]);
    } else {
      if (nominDetOptions.length > 0) {
        setNominees(nominDetOptions[0]);
        setDpToReplicate(nominDetOptions[0]);
      }
    }
    //dp
    getPersonalDetails();
    setDpDetails(resp[0].DematDetails);
    //nomindet
  }, [props.nomineeDet]);

  useEffect(() => {
    let dpData = dpOptions.find((ele: any) => {
      return ele.value === selectedDp;
    });
    if (dpData) {
      if (dpData.Demat_HolderType === "Joint") {
        setErrorMsg(
          "It seems that the DP Account is a joint holder account. This request cannot be processed online."
        );
      } else setErrorMsg("");
    }
  }, [selectedDp]);

  const setDpDetails = (dematDet: any) => {
    let dpOptions: any = [];

    dematDet.forEach((ele: any) => {
      if (ele.DematTagging !== "OUTSIDE_DP") {
        if (dpOptions.length === 0) {
          dpOptions.push({
            display: "Select DP Details",
            value: "",
          });
        }
        dpOptions.push({
          display: ele.Demat_Account_Number,
          value: ele.Demat_Account_Number,
          ...ele,
        });
      }
    });
    if (dpOptions.length > 2) {
      setDpOptions(dpOptions);
      // setDpToReplicate(dpOptions[1]);
    } else if (dpOptions.length === 2) {
      setDpOptions(dpOptions);
      setSelectedDp(dpOptions[1].value);
    }
    //dp
  };

  const downloadAttachment = async () => {
    if (
      props.nomineeDet[0].TradingDetails.fileExtension.toLowerCase() === "pdf"
    )
      await esignService.base64toPDF(
        props.nomineeDet[0].TradingDetails.TradingNomimeeForm,
        "TradingDetails"
      );
    else if (
      props.nomineeDet[0].TradingDetails.fileExtension === "jpg" ||
      props.nomineeDet[0].TradingDetails.fileExtension === "jpeg"
    ) {
      console.log("open image");
      var a = document.createElement("a"); //Create <a>
      a.href =
        "data:application/pdf;base64," +
        props.nomineeDet[0].TradingDetails.TradingNomimeeForm; //Image Base64 Goes here
      a.download = "Image.png"; //File name Here
      a.click(); //Downloaded file
    }
  };
  const isMinor = (date: any) => {
    const age = ageCalculator(date);
    return age < 18;
  };

  //set payload for nominee array
  const setNominees = (dpDet: any) => {
    let totNominees: any = [];
    if (dpDet.Nominee_Details.length > 0) {
      dpDet.Nominee_Details.map((ele: any) => {
        let nominee: any = NOMINEE;
        let nominRel = applicantRelationships.find((rel: any) => {
          if (rel.code === String(Number(ele.NomineeRelationShip))) {
            return rel;
          }
        });
        nominee = {
          firstName: ele.FirstName.replace(/\./g, ""),
          middleName: ele.MiddleName.replace(/\./g, ""),
          lastName: ele.LastName.replace(/\./g, ""),
          title: ele.Title,
          address: {
            addr1: ele.AddressLine1.replace(/-/g, " "),
            addr2: ele.AddressLine2.replace(/-/g, " "),
            addr3: ele.AddressLine3.replace(/-/g, " "),
            addr4: ele.AddressLine4.replace(/-/g, " "),
            // city: "",
            // state: "",
            // pin: "",
            city: ele.City,
            state: ele.CState,
            pin: ele.PinCode,
            country: ele.Country,
            //   address:
            //   ele.AddressLine1 +
            //   (ele.AddressLine2 && " " + ele.AddressLine2) +
            //   (ele.AddressLine3 && " " + ele.AddressLine3) +
            //   (ele.AddressLine4 && " " + ele.AddressLine4),
          },
          phone: ele.Phone1,
          email: ele.EmailId,
          // minor: ele.MinorIndicator === "1" ? true : false,
          minor: isMinor(ele.BirthDate),
          guardian: false,
          birthdate: ele.BirthDate,
          nomPer: ele.NomineePercentage
            ? parseInt(String(ele.NomineePercentage))
            : "",
          nomRel: nominRel?.value,
          aadhar: "",
          bankAcc: "",
          pan: "",
          dpId: "",
          idTyp: "",
          attachment: {},
        };
        if (nominee.minor) {
          if (dpDet.Guardian_Details.length > 0) {
            let guardDet = dpDet.Guardian_Details.find((guard: any) => {
              return guard.SrNo === ele.SrNo;
            });
            if (guardDet.FirstName) {
              let nominRel = applicantRelationships.find((guardRel: any) => {
                if (
                  guardRel.code === String(Number(guardDet.NomineeRelationShip))
                )
                  return ele;
              });
              nominee.guard = {
                firstName: guardDet.FirstName,
                middleName: guardDet.MiddleName,
                lastName: guardDet.LastName,
                title: guardDet.Title,
                address: {
                  addr1: guardDet.AddressLine1.replaceAll("-", ""),
                  addr2: guardDet.AddressLine2.replaceAll("-", ""),
                  addr3: guardDet.AddressLine3.replaceAll("-", ""),
                  addr4: guardDet.AddressLine4.replaceAll("-", ""),
                  city: guardDet.City,
                  state: guardDet.CState,
                  pin: guardDet.PinCode,
                  country: guardDet.Country,
                },
                phone: guardDet.Phone1,
                email: guardDet.EmailId,
                minor: isMinor(guardDet.BirthDate),
                // minor: guardDet.MinorIndicator === "1" ? true : false,
                guardian: true,
                birthdate: guardDet.BirthDate,
                nomPer: "",
                nomRel: nominRel?.value,
                aadhar: "",
                bankAcc: "",
                pan: "",
                dpId: "",
                idTyp: "",
                attachment: {},
              };
            }
          } else {
            nominee.guard = NOMINEE;
            nominee.guard.guardian = true;
            nominee.guard.nomPer = "";
            nominee.minor = true;
          }
        } else if (isMinor(ele.BirthDate)) {
          nominee.guard = NOMINEE;
          nominee.guard.guardian = true;
          nominee.guard.nomPer = "";
          nominee.minor = true;
        }

        totNominees.push(nominee);
      });
      setTotalNominee(totNominees);
      if (!editNomin && dpDet.hasOwnProperty("DematTagging"))
        setoldNominees(totNominees);
    }
  };
  useEffect(() => {
    let expetedGurdian = [];
    if (totalNominee.length > 1 && typeof sameGuardian === "boolean") {
      for (let i = 0; i < totalNominee.length - 1; i++) {
        if (expetedGurdian.length > 0) {
          for (let j = 0; j < expetedGurdian.length; j++) {
            if (
              expetedGurdian[j].firstName !== totalNominee[i].guard.firstName
            ) {
              expetedGurdian.push(totalNominee[i].guard);
              setGuardianData(expetedGurdian);
            }
          }
        } else {
          expetedGurdian.push(totalNominee[i].guard);
          setGuardianData(expetedGurdian);
        }
      }
      setSameGuardian(undefined);
    }
  }, [sameGuardian, updateShowDetails]);
  useEffect(() => {
    // console.log("totalNominee", totalNominee);
    // console.log(totalNominee);

    if (totalNominee.length > 1) {
      setUpdateShowDetails(!updateShowDetails);
      for (let i = 0; i < totalNominee.length - 1; i++) {
        if (totalNominee[i].minor) {
          setIsGuardianAvailable(true);
        }
      }
    }
  }, [totalNominee]);
  useImperativeHandle(ref, () => ({
    submitData() {
      let hasErr = false;
      let updateObj: any = {};
      if (dpOptions.length > 1 && selectedAcc !== "trading") {
        if (!selectedDp) {
          updateObj.dp = "Please select DP Id";
          hasErr = true;
        }
      }

      if (nominOptions.length > 1) {
        if (!selectedNominee) {
          updateObj.selectedNominee = "Please select nominee";
          hasErr = true;
        }
      }

      const nomineeVal = nomineeRef.map((x: any) => {
        return x.validation();
      });

      const guardVal = guardianRef.map((x: any) => {
        if (x) return x.validation();
        else return true;
      });
      const isValid = [...nomineeVal, ...guardVal].every((x) => x === true);
      // if (!isValid) updateObj.identifForm = "Please select nominee";

      setErrors({
        ...errors,
        ...updateObj,
      });
      if (isValid && !hasErr) {
        let dpId = selectedDp;

        if (!selectedDp || selectedAcc === "trading") {
          //if only trading visible/ trading option selected
          if (props.nomineeDet)
            props.nomineeDet[0].DematDetails.forEach((ele: any) => {
              if (ele.DefaultDemat === "Yes") dpId = ele.Demat_Account_Number;
            });
        }
        let nomTyp = "Modification";
        let minorClient = "No";
        props.nomineeDet[0].DematDetails.forEach((ele: any) => {
          if (ele.Demat_Account_Number === dpId) {
            nomTyp =
              ele.Nominee_Details.length > 0 ? "Modification" : "Addition";
            if (ele.Minor && ele.Minor.trim()) minorClient = ele.Minor;
          }
        });
        let status = "Approved";
        let nominees = totalNominee.map((ele: any) => {
          if (
            ele.attachment.nm &&
            ele.attachment.docType !== "PhotographAndSignature"
          )
            if (!ele.qcFlag) status = "QCPending";

          if (!ele.attachment.nm) delete ele.attachment;
          if (ele.guard) {
            if (
              ele.guard.attachment.nm &&
              ele.guard.attachment.docType !== "PhotographAndSignature"
            )
              if (!ele.guard.qcFlag) status = "QCPending";

            if (!ele.guard.attachment.nm) delete ele.guard.attachment;
          }
          if (ele.lastName === "") {
            ele.lastName = ".";
          }

          if (ele.address) {
            Object.keys(ele.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.address[k].length; i++) {
                    str += "-";
                  }
                  ele.address[k] += str;
                }
              }
            });
          }
          if (ele.hasOwnProperty("guard")) {
            if (ele.guard.lastName === "") {
              ele.guard.lastName = ".";
            }
            Object.keys(ele.guard.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.guard.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.guard.address[k].length; i++) {
                    str += "-";
                  }
                  ele.guard.address[k] += str;
                }
              }
            });
          }
          return ele;
        });
        let reqObj = {
          acTyp: LoginService.getAccData("accTyp"),
          dpId: dpId,
          // trdOpt: false,
          // dpOpt: false,
          trdUpd: selectedAcc.includes("trading"),
          dpUpd: selectedAcc.toLowerCase().includes("demat"),
          reqTyp:
            (selectedAcc === "tradingDemat" && "trading+demat") ||
            (selectedAcc === "trading" && "trading") ||
            (selectedAcc === "demat" && "demat"),
          nomTyp: nomTyp,
          subStatus: status,
          minorClient: minorClient,
          nominees: nominees,
        };
        return reqObj;
      } else {
        (
          document.getElementsByClassName("modal-Sr")[0] as HTMLDivElement
        ).scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        return false;
      }
    },
  }));
  return (
    <>
      {props.nomineeDet && (
        <>
          <div className="nomination">
            {/* <div className="msg">
          <p className="blue-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed metus
            nunc, accumsan ultricies orci eget, maximus tristique leo.
          </p>
        </div> */}
            {/* //nominee dropdown  */}
            {nominOptions.length > 1 && (
              <div className="nomineeDetails">
                <div className="custom--row progressbar_row tradingAccnt">
                  <div className="form-field custom-col noLeftPAdding space-mt-3">
                    <label className="input-label">Nominee Details</label>
                    <TocDropdown
                      selectedValue={
                        nominOptions.length > 0 ? selectedNominee : ""
                      }
                      dropdownOptions={nominOptions}
                      onSelect={(val: any) => {
                        setSelectedNominee(val);
                        let dpDet = nominOptions.find((ele: any) => {
                          if (val != "trading") {
                            return ele.Demat_Account_Number === val;
                          } else {
                            // return ele.DefaultDemat === "Yes";
                          }
                        });
                        if (dpDet) {
                          setDpToReplicate(dpDet);
                          setNominees(dpDet);
                          setErrors({ ...errors, selectedNominee: "", dp: "" });
                        } else {
                          setTotalNominee([]);
                        }
                      }}
                      isSearchable={false}
                    />
                  </div>
                  {/* <div className="custom-col"></div> */}
                  {errors.selectedNominee && (
                    <div className="custom-col-100">
                      <p className="error">{errors.selectedNominee}</p>
                    </div>
                  )}
                </div>
              </div>
            )}
            {/*  */}

            {/* //display section */}
            {(selectedNominee || nominOptions.length === 0) &&
              totalNominee.length <= 3 && (
                <>
                  {/* {dpToReplicate.hasOwnProperty("DematTagging") && (
                  <>
                    {
                      <NomineeDisplaySection
                        details={dpToReplicate}
                        // setEdit={setEditNomin}
                        // editNomin={editNomin}
                        setEdit={() => {
                          setEditNomin(true);
                        }}
                        editNomin={true}
                      />
                    }
                  </>
                )} */}

                  {/* //dp and trading dropdown */}
                  {(nominOptions.length > 0
                    ? selectedNominee && !selectedNominee.includes("trading")
                    : true) && (
                    <div className="dpDetailsWrap space-mt-3">
                      <div>
                        <h6 className="replicateHead">
                          Replicate Nominee Details in
                        </h6>
                      </div>
                      <AccounTypeSection
                        setAccountType={(val: any) => {
                          setSelectedAcc(val);
                          if (val === "trading") {
                            setErrorMsg("");
                            setErrors({ ...errors, dp: "" });
                          }
                        }}
                        onlyTrading={dpOptions.length === 0 ? 1 : 0}
                      />

                      <DpTrading
                        dpOptions={dpOptions}
                        selectedAcc={selectedAcc}
                        selectedDp={selectedDp}
                        setSelectedDp={setSelectedDp}
                        setErrors={setErrors}
                        errors={errors}
                        errorMsg={errorMsg}
                        accountCode={
                          props.nomineeDet[0].TradingDetails.AccountCode
                        }
                      />
                      {editNomin &&
                        totalNominee?.length > 0 &&
                        totalNominee.map((no: any, i: any) => {
                          return (
                            <div key={i}>
                              <NomineeGuardianForm
                                type={1}
                                id={i}
                                updateNominee={setTotalNominee}
                                nominee={totalNominee}
                                userPan={userPan}
                                accountCode={props.accountCode}
                                isGuardianAvailable={isGuardianAvailable}
                                setSameGuardian={setSameGuardian}
                                sameGuardian={sameGuardian}
                                setLoader={props.setLoader}
                                key={i}
                                ref={(ref) => (nomineeRef[i] = ref)}
                                enableSubmit={(val: any) => {
                                  props.enableSubmit(val);
                                }}
                                dpType={DPType}
                              />
                              {no.minor && (
                                <div>
                                  {no.sameas ? (
                                    <ShowDetails
                                      totalNominee={totalNominee}
                                      setTotalNominee={setTotalNominee}
                                      GuardianData={GuardianData}
                                      id={i}
                                      key={i}
                                    />
                                  ) : (
                                    <NomineeGuardianForm
                                      type={2}
                                      id={i}
                                      userPan={userPan}
                                      // isGuardianAvailable={isGuardianAvailable}
                                      // accountCode={accountCode}
                                      updateNominee={setTotalNominee}
                                      nominee={totalNominee}
                                      setLoader={props.setLoader}
                                      key={i}
                                      ref={(ref) => (guardianRef[i] = ref)}
                                      enableSubmit={props.enableSubmit}
                                      dpType={DPType}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  )}
                  {/* / */}
                </>
              )}
            {/*  */}

            {selectedNominee &&
              selectedNominee.includes("trading") &&
              props.nomineeDet[0].TradingDetails.TradingNomimeeForm && (
                <div>
                  <a
                    onClick={() => downloadAttachment()}
                    className="field-subHead grey-text blue-text small-text"
                  >
                    Click here &nbsp;
                  </a>
                  to check existing data
                </div>
              )}
          </div>

          {/* //identification Section */}
          {(dpToReplicate.hasOwnProperty("Nominee_Details") && !errorMsg
            ? dpToReplicate.Nominee_Details.length > 0
            : false) &&
            !editNomin &&
            totalNominee.length <= 3 &&
            selectedNominee &&
            !selectedNominee.includes("trading") &&
            totalNominee.map((no: any, i: any) => {
              return (
                <div key={i}>
                  <IdentificationForNominee
                    type={1}
                    id={i}
                    updateNominee={setTotalNominee}
                    nominee={totalNominee}
                    accountCode={props.accountCode}
                    userPan={userPan}
                    key={i}
                    setLoader={props.setLoader}
                    ref={(ref) => (nomineeRef[i] = ref)}
                    enableSubmit={(val: any) => {
                      if (errors.dp || errors.selectedNominee)
                        props.enableSubmit(false);
                      else props.enableSubmit(val);
                    }}
                  />
                  {no.minor && (
                    <IdentificationForNominee
                      type={2}
                      id={i}
                      accountCode={props.accountCode}
                      updateNominee={setTotalNominee}
                      nominee={totalNominee}
                      userPan={userPan}
                      key={i}
                      setLoader={props.setLoader}
                      ref={(ref) => (guardianRef[i] = ref)}
                      enableSubmit={(val: any) => {
                        if (errors.dp || errors.selectedNominee)
                          props.enableSubmit(false);
                        else props.enableSubmit(val);
                      }}
                    />
                  )}
                </div>
              );
            })}
        </>
      )}
      {totalNominee.length > 3 && (
        <div className="space-mt-1">
          <p className="error">
            More than 3 nominees are not allowed. Please select update nominee
            option and update details.
          </p>
        </div>
      )}
      {selectedNominee && selectedNominee.includes("trading") && (
        <div className="space-mt-1">
          <p className="error">
            Please update nominee details from update nominee option.
          </p>
        </div>
      )}
    </>
  );
});
